import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
	timeout: 30000, // 30 segundos timeout
	headers: {
		'Content-Type': 'application/json',
	},
});

// Interceptor para retry em caso de erro de rede
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const config = error.config;

		// Se não tem config ou já tentou 3 vezes, rejeita
		if (!config || config.__retryCount >= 3) {
			return Promise.reject(error);
		}

		// Incrementa contador de tentativas
		config.__retryCount = config.__retryCount || 0;
		config.__retryCount += 1;

		// Retry apenas em erros de rede ou timeout
		if (
			error.code === 'ECONNABORTED' ||
			error.code === 'ERR_NETWORK' ||
			error.message.includes('timeout') ||
			error.message.includes('Network Error')
		) {
			console.log(`Tentativa ${config.__retryCount} de 3 para ${config.url}`);
			
			// Aguarda 1 segundo antes de tentar novamente
			await new Promise(resolve => setTimeout(resolve, 1000));
			
			return api(config);
		}

		return Promise.reject(error);
	}
);

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	timeout: 30000, // 30 segundos timeout
});

export default api;
